import { render, staticRenderFns } from "./AttentionBlock.vue?vue&type=template&id=4bb803c2"
import script from "./AttentionBlock.vue?vue&type=script&lang=js"
export * from "./AttentionBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports